// extracted by mini-css-extract-plugin
export var addToCartButton = "_ne-b";
export var arrowButtonContainer = "_ne-9";
export var arrowButtonIcon = "_ne-a";
export var carouselArrowButton = "_ne-6";
export var carouselElementContainer = "_ne-1";
export var left = "_ne-7";
export var productDisplayCarouselContainer = "_ne-0";
export var productTileContainer = "_ne-2";
export var productTileImage = "_ne-4";
export var productTileImageContainer = "_ne-3";
export var productTileTitle = "_ne-5";
export var right = "_ne-8";
export var sliderOverflow = "_ne-c";